import angular from 'angular';
import DonationsProgress from './donations-progress/donations-progress';
import DonationsSummary from './donations-summary/donations-summary';
import Home from './home/home';
import LastCommitments from './last-commitments/last-commitments';
import LastDonations from './last-donations/last-donations';
import Thanks from './thanks/thanks';

let componentModule = angular.module('app.components', [
  DonationsProgress,
  DonationsSummary,
  Home,
  LastCommitments,
  LastDonations,
  Thanks
])
  .name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js